import api from './api';
import type { OneOnOneNote, TeamOneOnOneEntry } from '@/types/index';

export interface OneOnOneNotePayload {
  meetingDate: string;
  channel?: string;
  summary: string;
}

export const oneOnOneService = {
  async getMyNotes(): Promise<OneOnOneNote[]> {
    const res = await api.get('/one-on-ones/my');
    return res.data.data;
  },

  async getUserNotes(userId: string | number): Promise<OneOnOneNote[]> {
    const res = await api.get(`/one-on-ones/user/${userId}`);
    return res.data.data;
  },

  async getTeamNotes(): Promise<TeamOneOnOneEntry[]> {
    const res = await api.get('/one-on-ones/team');
    return res.data.data;
  },

  async createNote(payload: OneOnOneNotePayload): Promise<OneOnOneNote> {
    const res = await api.post('/one-on-ones', payload);
    return res.data.data;
  },

  async updateNote(id: string, payload: OneOnOneNotePayload): Promise<OneOnOneNote> {
    const res = await api.put(`/one-on-ones/${id}`, payload);
    return res.data.data;
  },

  async deleteNote(id: string): Promise<void> {
    await api.delete(`/one-on-ones/${id}`);
  },
};
